<template>
<div>
    <!-- ##### Breadcumb Area Start ##### -->
    <div class="breadcumb-area bg-img" :style="'background-image: url('+ require('@/assets/contact/contact.jpg') + ')'">
        <div class="container h-100">
            <div class="row h-100 align-items-center">
                <div class="col-12 col-md-6">
                    <div class="breadcumb-text">
                        <h2>Gracias por Contactarnos</h2>
                        <p>
                            Estaremos contactándote pronto 
                            Dios te bendiga
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- ##### Breadcumb Area End ##### -->

</div>
  
</template>


<script>
export default {
  data() {
    return { };
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.breadcumb-area::after {
  background-color: none !important ;
}
</style>